import supabase from "../../supabaseClient.js";

interface PastorRegistration {
  id: number;
  email: string;
  auth_id: string | null;
  full_name: string | null;
  church_name: string | null;
  denomination: string | null;
  country: string | null;
  phone: string | null;
  certificate_url: string | null;
  certificate_name: string | null;
  verification_status: string;
  admin_notes: string | null;
  created_at: string;
}

export class AxiosPastorVerification {
  public async getAllPastors(): Promise<{
    data?: PastorRegistration[];
    error?: string;
  }> {
    const { data, error } = await (supabase as any)
      .from("pastor_registrations")
      .select("*")
      .order("verification_status", { ascending: true })
      .order("created_at", { ascending: false });

    if (error) {
      console.error("Error fetching pastor registrations:", error.message);
      return { error: error.message };
    }

    return { data: data as PastorRegistration[] };
  }

  public async approvePastor(
    id: number
  ): Promise<{ success: boolean; error?: string }> {
    try {
      const { error } = await (supabase as any)
        .from("pastor_registrations")
        .update({ verification_status: "approved" })
        .eq("id", id);

      if (error) {
        console.error("Error approving pastor:", error.message);
        return { success: false, error: error.message };
      }

      return { success: true };
    } catch (err) {
      console.error("Exception approving pastor:", err);
      return {
        success: false,
        error: err instanceof Error ? err.message : "Unknown error",
      };
    }
  }

  public async rejectPastor(
    id: number,
    notes?: string
  ): Promise<{ success: boolean; error?: string }> {
    try {
      const updatePayload: any = {
        verification_status: "rejected",
      };

      if (notes) {
        updatePayload.admin_notes = notes;
      }

      const { error } = await (supabase as any)
        .from("pastor_registrations")
        .update(updatePayload)
        .eq("id", id);

      if (error) {
        console.error("Error rejecting pastor:", error.message);
        return { success: false, error: error.message };
      }

      return { success: true };
    } catch (err) {
      console.error("Exception rejecting pastor:", err);
      return {
        success: false,
        error: err instanceof Error ? err.message : "Unknown error",
      };
    }
  }
}

export default new AxiosPastorVerification();
